import { useState } from 'react';

import BrandRecipientsModal from './BrandRecipientsModal';

// Drop-in reusable recipients editor: render `recipientsModal` once, then call
// `openRecipients({ Brand_id })` from any button. The modal loads the brand's recipients itself;
// `renderActions` is shared config applied to every open.
export const useBrandRecipientsModal = (options = {}) => {
  const { renderActions } = options;
  const [openForBrandId, setOpenForBrandId] = useState(null);

  const openRecipients = ({ Brand_id }) => setOpenForBrandId(Brand_id);
  const recipientsModal = openForBrandId ? (
    <BrandRecipientsModal Brand_id={openForBrandId} onClose={() => setOpenForBrandId(null)} renderActions={renderActions} />
  ) : null;

  return { openRecipients, recipientsModal };
};
